<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hVA0v5/tc-custom/9780292747517.jpg?1716663320542" alt="This image is the cover for the book This Is Jerusalem Calling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Is Jerusalem Calling
      </h1>
      <p class="bookDescription body article font2">
        <b>“Stanton’s analysis of radio as a new tool of the colonial state contributes a great deal to studies of Mandate Palestine and imperialism.” –<i>Journal of Palestinian Studies</i></b><br/>  <br/> Modeled after the BBC, the Palestine Broadcasting Service was launched in 1936 to serve as the national radio station of Mandate Palestine, playing a pivotal role in shaping the culture of the emerging middle class in the region. Despite its significance, the PBS has become nearly forgotten by scholars of twentieth-century Middle Eastern studies. Drawn extensively from British and Israeli archival sources, <i>“This Is Jerusalem Calling”</i> traces the compelling history of the PBS’s twelve years of operation, illuminating crucial aspects of a period when Jewish and Arab national movements simultaneously took form.<br/>  <br/> Andrea L. Stanton describes the ways in which the mandate government used broadcasting to cater to varied audiences, including rural Arab listeners, in an attempt to promote a “modern” vision of Arab Palestine as an urbane, politically sophisticated region. In addition to programming designed for the education of the peasantry, religious broadcasting was created to appeal to all three main faith communities in Palestine, which ultimately may have had a disintegrating, separatist effect. Stanton’s research brings to light the manifestation of Britain’s attempts to prepare its mandate state for self-governance while supporting the aims of Zionists. While the PBS did not create the conflict between Arab Palestinians and Zionists, the service reflected, articulated, and magnified such tensions during an era when radio broadcasting was becoming a key communication tool for emerging national identities around the globe.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea L. Stanton
      </h2>
      
      <p class="authorDescription body article">Andrea L. Stanton is an Assistant Professor in the Religious Studies Department at the University of Denver. Trained as a historian, her research focuses on the twentieth-century Middle East, and particularly at intersections between technology, communications media, and identity formation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72998d92